module.exports = __webpack_public_path__ + "static/media/ic_dropdown.5ffcff0c.svg";